// extracted by mini-css-extract-plugin
module.exports = {"root":"p_m9YY","product":"q4uTL8"};